@if (isVisible) {
  <button
    class="universal-back-btn"
    (click)="goBack()"
    appTvFocusable
    aria-label="Go Back"
  >
    <!-- Chevron Left Icon -->
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M15 18l-6-6 6-6" />
    </svg>
  </button>
}
